import * as Apollo from '@apollo/client';
import { useQuery } from '@apollo/client';

export default function usePersistedCacheQuery<Query, QueryVariables>(
  query: Apollo.DocumentNode,
  options: Apollo.QueryHookOptions<Query, QueryVariables>
): Apollo.QueryResult<Query, QueryVariables> {
  const result = useQuery<Query, QueryVariables>(query, {
    ...options,
    fetchPolicy: 'cache-and-network'
  });

  const isActuallyLoading =
    result.loading &&
    !result.client.readQuery({
      query,
      variables: options?.variables
    });

  return {
    ...result,
    loading: isActuallyLoading
  };
}
